module.exports = __webpack_public_path__ + "img/snapshot_cat_20190531_161422.e3dbadce.png";